import React from "react";

import styles from "./Image.module.scss";

interface Props {
    src: string;
    alt: string;
}

const Image = ({ src, alt }: Props) => {
    return <img className={styles["img"]} src={src} alt={alt} />;
};

export default Image;
